export default "__VITE_ASSET__be39ce3c__"